var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5129 0.147766C10.0079 0.147766 0.648438 9.50719 0.648438 21.0122C0.648438 32.5173 10.0079 41.8767 21.5129 41.8767C33.0179 41.8767 42.3774 32.5173 42.3774 21.0122C42.3774 9.50719 33.0179 0.147766 21.5129 0.147766ZM27.9583 22.2415L19.2648 30.935C18.9257 31.274 18.4806 31.4445 18.0355 31.4445C17.5904 31.4445 17.1452 31.274 16.8062 30.935C16.1264 30.2552 16.1264 29.1563 16.8062 28.4765L24.2705 21.0122L16.8063 13.548C16.1264 12.8682 16.1264 11.7693 16.8063 11.0895C17.4861 10.4097 18.5849 10.4097 19.2648 11.0895L27.9583 19.783C28.6381 20.4628 28.6381 21.5616 27.9583 22.2415Z",
    fill: "url(#paint0_linear_3285_632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3285_632",
    x1: 21.5129,
    y1: 0.147766,
    x2: 21.5129,
    y2: 41.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2378DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.2807f504ecf9921cab34565dbd6983df.svg";
export { ForwardRef as ReactComponent };